<template>
  <div class="confirm-overlay" @click.self="onCancel">
    <div class="confirm-box" :class="{ wide: secondaryLabel }">
      <p class="confirm-message" v-html="message"></p>
      <div class="confirm-buttons">
        <button type="button" class="btn-cancel" @click="onCancel">{{ cancelLabel }}</button>
        <button v-if="secondaryLabel" type="button" class="btn-secondary" @click="onSecondary">{{ secondaryLabel }}</button>
        <button type="button" class="btn-confirm" @click="onConfirm">{{ confirmLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmModal",
  props: {
    message: { type: String, required: true },
    confirmLabel: { type: String, default: "Zatwierdź" },
    cancelLabel: { type: String, default: "Anuluj" },
    // Opcjonalny trzeci przycisk (np. "Cofnij bez zapisywania").
    secondaryLabel: { type: String, default: "" },
  },
  emits: ["confirm", "cancel", "secondary"],
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
    onSecondary() {
      this.$emit("secondary");
    },
  },
};
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060;
}
.confirm-box {
  background: #fff;
  border-radius: 8px;
  padding: 28px 24px 20px;
  width: 460px;
  max-width: 92vw;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  text-align: center;
}
/* Szersze okno, gdy są trzy przyciski - żeby zmieściły się w jednym rzędzie. */
.confirm-box.wide {
  width: 640px;
}
.confirm-message {
  font-size: 14px;
  color: #090741;
  margin-bottom: 22px;
  line-height: 1.5;
}
.confirm-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
.btn-cancel,
.btn-secondary,
.btn-confirm {
  border: none;
  border-radius: 6px;
  padding: 9px 22px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.btn-cancel {
  background: #090741;
  color: #fff;
}
.btn-secondary {
  background: #ececf4;
  color: #090741;
}
.btn-confirm {
  background: linear-gradient(90deg, #fb8928, #e50582);
  color: #fff;
}
</style>
